import apiConnect from '@/lib/api-connect'
import axios from 'axios'

export const SUCCESS_CODE = '0000'

/** キーワード検索用API */
export const getSearchFolderByKeyword = (
  officeId: string,
  fileId: string,
  keyword: string,
  childId: string
) => {
  try {
    return apiConnect.postToApiGateway('cloud', {
      act: 'search_folder_by_keyword',
      officeId,
      fileId,
      keyword,
      childId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/** ファイルIDからフォルダリストを取得するAPI */
export const getListFolderByFileId = (officeId: string, fileId: string) => {
  try {
    return apiConnect.postToApiGateway('cloud', {
      act: 'list_folder_by_file_id',
      officeId,
      fileId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/** 事業所or児童からファイルリストを取得するAPI */
export const getListPrimaryFolder = (officeId: string, childId: string) => {
  try {
    return apiConnect.postToApiGateway('cloud', {
      act: 'list_primary_folder',
      officeId,
      childId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/** 児童とフォルダを紐づけ初期設定を行うAPI */
export const postLinkChild = (
  officeId: string,
  childId: string,
  staffId: string
) => {
  try {
    return apiConnect.postToApiGateway('cloud', {
      act: 'link_child',
      officeId,
      childId,
      staffId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/** ファイルをアップロードするURLを取得するAPI */
export const getGenerateUploadUrl = ({
  officeId,
  targetFolderId,
  fileName,
  fileType,
  staffId,
}: {
  officeId: string
  targetFolderId: string
  fileName: string
  fileType: string
  staffId: string
}) => {
  try {
    return apiConnect.postToApiGateway('cloud', {
      act: 'generate_upload_url',
      officeId,
      targetFolderId,
      fileName,
      fileType,
      staffId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/** ファイルをアップロードするAPI */
export const putUploadFile = ({
  uploadUrl,
  fileData,
}: {
  uploadUrl: string
  fileData: File
}) => {
  try {
    return axios.put(uploadUrl, fileData, {
      headers: {
        'Content-Type': fileData.type || 'text/plain',
      },
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/** フォルダを作成するAPI */
export const postCreateFolderByParentFolderId = ({
  officeId,
  staffId,
  folderName,
  parentFolderId,
}: {
  officeId: string
  staffId: string
  folderName: string
  parentFolderId: string
}) => {
  try {
    return apiConnect.postToApiGateway('cloud', {
      act: 'create_folder_by_parent_folder_id',
      folderName,
      officeId,
      staffId,
      parentFolderId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/** ファイルをダウンロードするURLを取得するAPI */
export const getDownloadLink = ({
  officeId,
  staffId,
  fileId,
}: {
  officeId: string
  staffId: string
  fileId: string
}) => {
  try {
    return apiConnect.postToApiGateway('cloud', {
      act: 'get_download_link',
      officeId,
      staffId,
      fileId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/** ファイルを削除するAPI */
export const delateTrashFileByFileId = ({
  officeId,
  staffId,
  fileId,
}: {
  officeId: string
  staffId: string
  fileId: string
}) => {
  try {
    return apiConnect.postToApiGateway('cloud', {
      act: 'trash_file_by_file_id',
      officeId,
      staffId,
      fileId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/** フォルダ・ファイル名を変更するAPI */
export const putChangeFileName = ({
  officeId,
  staffId,
  fileId,
  newFileName,
}: {
  officeId: string
  staffId: string
  fileId: string
  newFileName: string
}) => {
  try {
    return apiConnect.postToApiGateway('cloud', {
      act: 'change_file_name',
      officeId,
      staffId,
      fileId,
      newFileName,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/** ログファイルをダウンロードするAPI */
// MEMO: 現在の仕様では、出力パターンは2つのみであるため、fetchDaysの型を指定していない
export const getDownloadLog = ({
  officeId,
  logOutputType,
  fetchDays,
}: {
  officeId: string
  logOutputType: 'days' | 'all'
  fetchDays?: 90
}) => {
  try {
    return apiConnect.postToApiGateway('cloud', {
      act: 'download_log',
      officeId,
      logOutputType,
      fetchDays,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/** ファイルをコピーするAPI */
export const postCopyFile = ({
  officeId,
  fileId,
  staffId,
}: {
  officeId: string
  fileId: string
  staffId: string
}) => {
  try {
    return apiConnect.postToApiGateway('cloud', {
      act: 'copy_file',
      officeId,
      fileId,
      staffId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/** 権限が付与されているユーザーを取得するAPI */
export const getPermissionUsers = ({
  officeId,
  fileId,
}: {
  officeId: string
  fileId: string
}) => {
  try {
    return apiConnect.postToApiGateway('cloud', {
      act: 'list_permission_by_file_id',
      officeId,
      fileId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}
